import { render, staticRenderFns } from "./NoticeModeration.vue?vue&type=template&id=b2056066&scoped=true&"
import script from "./NoticeModeration.vue?vue&type=script&lang=js&"
export * from "./NoticeModeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2056066",
  null
  
)

export default component.exports